import { render, staticRenderFns } from "./PartnershipSales.vue?vue&type=template&id=288b63ea&"
import script from "./PartnershipSales.vue?vue&type=script&lang=js&"
export * from "./PartnershipSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports